import { InputValue, SelectionCardGroup, SelectionCardGroupProps } from '@optimus-web/core';
import { ControllerProps, useControllerWithEventHandler } from '../hooks';

type FormSelectionCardGroupFieldProps = Omit<SelectionCardGroupProps, 'onChange' | 'inputValue'> &
    Omit<ControllerProps, 'transform'> & {
        hideError?: boolean;
        onChange?: (value: InputValue | InputValue[]) => void;
    };

export const FormSelectionCardGroupField = ({
    defaultValue,
    hideError = false,
    name,
    rules,
    shouldUnregister,
    onChange,
    ...other
}: FormSelectionCardGroupFieldProps) => {
    const { value, error, handleChange, onBlur, context } = useControllerWithEventHandler({
        defaultValue,
        name,
        rules,
        shouldUnregister,
        onChange: (_e, v) => {
            onChange?.(v as InputValue | InputValue[]);
        },
    });

    return (
        <SelectionCardGroup
            {...other}
            inputValue={value}
            onChange={handleChange}
            error={hideError ? undefined : error}
            onBlur={onBlur}
            disabled={context?.readOnly || other.disabled}
        />
    );
};
